export default "__VITE_ASSET__IHgazlWl__"